export const LOGO_URL = "https://customer-assets.emergentagent.com/job_custom-tarp-calc/artifacts/gdn4vmqz_printad_portraitlogo.png";
export const LOGO_HERO_URL = "https://customer-assets.emergentagent.com/job_custom-tarp-calc/artifacts/mlkq03vd_Print%20Ad%20Venture%20Logo%20%20%28%20Transparent%202%20%29.png";
export const HERO_BG_URL = "https://customer-assets.emergentagent.com/job_custom-tarp-calc/artifacts/mu7v6pax_bgmain.jpeg";

export const COMPANY = {
  name: "Print Ad Venture",
  legal: "Print Ad Venture Inc.",
  address: "17 Blumentritt St., Brgy. Tinago, Naga City, Philippines 4400",
  email: "sales@printad.ph",
  website: "printad.ph",
  phone: "+63 919 831 3310",
  hours: "Mon–Sat • 8:00 AM – 6:00 PM",
};
